<form [formGroup]="form" (ngSubmit)="save()">
    <div class="c-acc-panel c-acc-panel--edit">
    <div class="c-form-field no-margin-bottom">
      <label class="c-form-field__label">
        <span data-cy="personalized-coaching-header">{{ 'MY-ACCOUNT/MY-PRIVACY.AllowPersonalizedCoaching' | translate}}</span>
      </label>
      <div class="c-form-field__input">
        <div class="c-input c-input--checkbox">
          <input formControlName="allowPersonalizedCoaching" type="checkbox" id="allowPersonalizedCoaching" data-cy="personalized-coaching-checkbox">
          <label class="c-form-field__label" for="allowPersonalizedCoaching">{{ 'MY-ACCOUNT/MY-PRIVACY.AllowPersonalizedCoaching' | translate}}</label>
        </div>
      </div>
    </div>
    <div class="personalized-coaching-description" data-cy="personalized-coaching-description">{{ 'MY-ACCOUNT/MY-PRIVACY.AllowPersonalizedCoachingDescription' | translate }}</div>

    <div class="c-form-buttons  [ o-layout o-layout--auto ]">
      <div class="o-layout__item">
        <button type="submit" class="c-btn c-btn--primary" data-cy="personalized-coaching-save-btn">{{ 'MY-ACCOUNT/MY-PRIVACY.Save' | translate}}</button>
      </div>
      <div class="o-layout__item">
        <a class="c-btn c-btn--tertiary" data-cy="personalized-coaching-cancel-btn" (click)="cancel()">{{ 'MY-ACCOUNT/MY-PRIVACY.Cancel' | translate}}</a>
      </div>
    </div>
  </div>
</form>
